import { useDateUtils } from '../Utilities/useDateUtils';

interface DateColumnProps {
    header: string,
    accessor: string,
    width?: string,
    className?: string 
    includeSeconds?: boolean
}

function DateColumn({ header, accessor, width = undefined, className = undefined, includeSeconds = false }: DateColumnProps) {

    if (accessor === undefined) {
        throw new Error("DateColumn requires an accessor");
    }


    return {
        Header: header,
        accessor: accessor,
        Cell: (props: any) => <DateCell className={className} value={props.value} includeSeconds={includeSeconds} />,
        disableFilters: true,
        width: width
    };
}

interface DateCellProps {
    className?: string,
    value: any
    includeSeconds?:boolean,
}


function DateCell({ className, value, includeSeconds=false }: DateCellProps) {
    const { convertUTCToShortDateTime, convertUTCToShortDateTimeSecs } = useDateUtils();

    return (
        <div className={className}>{includeSeconds ? convertUTCToShortDateTimeSecs(value) : convertUTCToShortDateTime(value)}</div>
    );
}

export default DateColumn;